import React, { Component } from 'react';

import UserRow from './UserRow';

class UserTable extends Component {
  render = () => {
    return (
      <div>
        <h2 className="form-title">User Management</h2>
        <div className="form-group">
          <div className="col-md-12">
            <div className="col-md-12 profile-dashboard">

              <div id="custom-search-input">
                <div className="input-group col-md-12">
                  <input 
                    type="text"
                    className="form-control input-lg"
                    placeholder="Search"
                    onChange={this.props.searchFunction}
                  />
                </div>
              </div>

              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">User ID</th>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">Groups</th>
                    <th scope="col">Verified</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.props.data.map((user,index) => {
                      return (
                        <UserRow
                          key={user.uid}
                          uid={user.uid}
                          email={user.email}
                          cn={user.firstName}
                          sn={user.lastName}
                          groups={user.groups}
                          enabled={user.enabled}
                          verified={user.verified}
                          editUser={() => this.props.edit(user)}
                        />
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UserTable;


// WEBPACK FOOTER //
// ./src/Components/userManagement/UserTable.js